<template>
  <div class="form-actions">
    <button
      v-if="isSteps && !isFirstStep"
      class="form-actions__button"
      key="back-button"
      type="button"
      :disabled="disabled"
      @click="$emit('back')"
    >
      {{ backLabel }}
    </button>

    <button
      v-if="isSteps && !isLastStep"
      class="form-actions__button"
      key="next-button"
      type="button"
      :disabled="disabled"
      @click="$emit('next')"
    >
      {{ nextLabel }}
    </button>

    <button v-else class="form-actions__button" key="submit-button" type="submit" :disabled="disabled" @click="$emit('submit')">
      {{ submitLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'FormActions',
  emits: ['back', 'next', 'submit'],
  props: {
    isSteps: {
      type: Boolean,
      default: false,
    },
    isFirstStep: {
      type: Boolean,
      default: true,
    },
    isLastStep: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    submitLabel: {
      type: String,
      default: 'Отправить',
    },
    nextLabel: {
      type: String,
      default: 'Далее',
    },
    backLabel: {
      type: String,
      default: 'Назад',
    },
  },
}
</script>

<style lang="sass">
.form-actions
  display: flex
  gap: 16px

  button.form-actions__button
    display: inline-block
    padding: 10px 22px 12px
    border-radius: 3px
    font-size: 16px
    line-height: 1.4
    min-width: 240px
    font-family: Segoe UI, sans-serif
    font-weight: 600
    cursor: pointer
    white-space: nowrap
    text-align: center
    border: 0
    color: var(--field-text-inverse-color)
    background-color: var(--form-action-bg-color)
    transition: color .2s, background-color .2s

    &:hover
      color: var(--form-action-text-hover-color)
      background-color: var(--form-action-bg-hover-color)

    &:disabled
      cursor: default
      pointer-events: none
      opacity: .6
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/components/FormActions.vue